<template>
  <div class="login-container">
    <h3 class="brand-title">HobiBaca</h3>
    <LoginForm @login-success="handleLoginSuccess" />
  </div>
</template>

<script>
import LoginForm from "@/components/LoginForm.vue";

export default {
  name: "LoginPage",
  components: {
    LoginForm,
  },
  methods: {
    handleLoginSuccess() {
      this.$router.push('/');
    },
  },
  useMeta() {
    return {
      title: 'Login - HobiBaca',
      meta: [
        { name: 'description', content: 'Login ke HobiBaca untuk mengakses semua buku di HobiBaca.' },
        { name: 'keywords', content: 'HobiBaca, login, membaca, buku' },
      ],
    };
  },  
};
</script>

<style scoped>
.login-container {
  max-width: 400px;
  margin: 50px auto;
  padding: 30px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.brand-title {
  font-size: 20px;
  font-weight: bold;
  color: #007bff;
  margin-bottom: 10px;
}
</style>
